import moment from 'moment';
import defaults from '../translations/en.json';
export const fromDateToDate = dashboardPrintConfig => {
  const fromDate = dashboardPrintConfig.fromDate && dashboardPrintConfig.fromDate[0];
  const toDate = dashboardPrintConfig.toDate && dashboardPrintConfig.toDate[0];
  return fromDate && toDate && `${defaults.From} ${moment(fromDate).format('l')} ${defaults.to} ${moment(toDate).format('l')}`;
};